module.exports = __webpack_public_path__ + "static/media/01.5d6e80d2.jpg";